import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";

export default function Services() {
  const services = [
    { title: "Global Shipping", desc: "Fast and reliable shipping worldwide." },
    { title: "Quality Assurance", desc: "We ensure top-quality products." },
    { title: "Custom Solutions", desc: "Tailored services for your needs." },
  ];

  return (
    <section id="services" className="py-5 bg-light">
      <Container>
        <h2 className="text-center mb-4">Our Services</h2>
        <Row>
          {services.map((service, idx) => (
            <Col md={4} key={idx}>
              <Card className="mb-4 shadow-sm">
                <Card.Body>
                  <Card.Title>{service.title}</Card.Title>
                  <Card.Text>{service.desc}</Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
}

